import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const ContainerBaseUrl = '/business/container'

export const queryContainers = async params => {
  const result = await request({
    url: ContainerBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search Container failed!') ?? null
}

export const detailContainer = async containerId => {
  const result = await request({
    url: ContainerBaseUrl,
    method: 'GET',
    params: {
      container_id: containerId
    }
  })
  return (
    ResultHandler(result, 'Search Container failed!')?.containers[0] ?? null
  )
}

export const updateContainer = async (containerId, data) => {
  const result = await request({
    url: ContainerBaseUrl + '/' + containerId,
    method: 'PUT',
    data
  })
  return ResultHandler(result, 'Update container failed')
}

export const searchContainer = async params => {
  const result = await request({
    url: ContainerBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search container failed!') ?? null
}
